export const PERMITTED_LOCATIONS_TYPES = {
  GET_LOCATIONS_BEGIN: 'GET_LOCATIONS_BEGIN',
  GET_LOCATIONS_SUCCESS: 'GET_LOCATIONS_SUCCESS',
  GET_LOCATIONS_ERROR: 'GET_LOCATIONS_ERROR',
};
